import React, { useState } from "react";
import { bool, func, string, object } from "prop-types";

import ContactTelephone from "./ContactTelephone";

const MobileTelephone = ({
  handleChange,
  mobileTelephone,
  validation,
  classes,
}) => (
  <ContactTelephone
    inputId="mobile_telephone"
    title="Mobile phone number"
    number={mobileTelephone}
    valueName="mobileTelephone"
    handleChange={handleChange}
    validation={validation}
    shouldDisplayError
    classes={classes}
  />
);

MobileTelephone.propTypes = {
  handleChange: func.isRequired,
  mobileTelephone: string.isRequired,
  validation: object,
  classes: string,
};

export default MobileTelephone;
